import { AuthenticationHeader } from "@novorender/data-js-api";

import { BackendProvider } from "config/backend";
import { StorageKey } from "config/storage";
import { getFromStorage } from "utils/storage";

export async function getAuthHeader(backendProvider?: BackendProvider): Promise<AuthenticationHeader> {
    // Don't return tokens for Procore backend - Procore uses cookie-based auth only
    if (backendProvider === "procore") {
        return { header: "", value: "" };
    }

    const accessToken = getFromStorage(StorageKey.AccessToken);

    if (!accessToken) {
        return { header: "", value: "" };
    }

    return { header: "Authorization", value: `Bearer ${accessToken}` };
}
